import * as Sentry from '@sentry/browser'
import sentryConfig from './sentryConfig'
export default class SentryWrapper {
    constructor() {
        if (!sentryConfig) {return}
        if (sentryConfig.environment === 'local') {return}
        // Pages that load a second bundle (optionplan, archetypes, startup jobs,
        // feedback, handbooks) construct this from both entries. The SDK is shared
        // through the global hub, so the first one to run wins and the rest are
        // no-ops — otherwise the global error handlers get installed twice and one
        // throw is captured by two clients, which Dedupe cannot see across.
        // Handbooks mixes bundlers, so the hub is only shared while package.json
        // and vite/package.json pin the same @sentry/browser version.
        if (Sentry.getClient()) {return}
        Sentry.init({
            dsn: sentryConfig.dsn,
            environment: sentryConfig.environment,
            release: sentryConfig.release,
            // Both default to true and both beacon on every pageview, whether or
            // not anything went wrong: a session envelope at init, and a client
            // report on tab hide. We use neither release health nor quota
            // accounting, so that is pure traffic. No tracing integration either
            // (IV-1701's Lighthouse run covers front-end performance), which
            // leaves errors as the only thing this reports.
            autoSessionTracking: false,
            sendClientReports: false,
        })
    }
}
